import MuiTypography from './MuiTypography';
import MuiTableCell from './MuiTableCell';

const overrides = {
	MuiTypography,
	MuiTableCell,
};

export default overrides;
